import React from "react";
import { surface, spacing } from "../../theme/tokens";
import PageHeader from "../PageLayout/PageHeader";

/**
 * Khung trang chuẩn của dashboard: header (breadcrumb + tiêu đề) + vùng nội dung.
 *
 * KHÔNG còn bọc ConfigProvider riêng. Trước đây file này đặt một theme antd thứ hai
 * lồng trong theme của RouterApp, hai bên khai colorPrimary khác nhau nên nút primary
 * đổi màu tuỳ màn có bọc layout hay không. Cấu hình antd giờ nằm đúng một chỗ:
 * RouterApp -> theme/dashboardTheme.js.
 *
 * @param {boolean} fitHeight  Trang vừa khít vùng nội dung của Layout, không đẩy
 *                             scrollbar ra ngoài. Bật kèm <ListTableCard fitHeight>
 *                             để chỉ thân bảng cuộn. Vùng nội dung vẫn để `overflow: auto`
 *                             nên mobile (nơi ListTableCard tự tắt fitHeight) vẫn cuộn bình thường.
 */
const BrandedPageLayout = ({
  children,
  title,
  subtitle,
  breadcrumbItems = [],
  extra,
  fitHeight = false,
}) => {
  return (
    <div
      style={{
        background: surface.page,
        ...(fitHeight
          ? { height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }
          : { minHeight: "100vh" }),
      }}
    >
      <PageHeader title={title} subtitle={subtitle} breadcrumb={breadcrumbItems} extra={extra} />
      <div
        style={{
          padding: `${spacing[6]}px ${spacing[6]}px ${spacing[8]}px`,
          ...(fitHeight
            ? {
              paddingBottom: spacing[6],
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
            }
            : null),
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BrandedPageLayout;
